const GET_HOME_PLAYLIST_LOADING = 'home/GET_HOME_PLAYLIST_LOADING'
const GET_HOME_PLAYLIST_SUCCESS = 'home/GET_HOME_PLAYLIST_SUCCESS'
const GET_HOME_PLAYLIST_ERROR = 'home/GET_HOME_PLAYLIST_ERROR'

const GET_HOME_BANNER_LOADING = 'home/GET_HOME_BANNER_LOADING'
const GET_HOME_BANNER_SUCCESS = 'home/GET_HOME_BANNER_SUCCESS'
const GET_HOME_BANNER_ERROR = 'home/GET_HOME_BANNER_ERROR'

const GET_HOME_VIDEO = 'home/GET_HOME_VIDEO'
const UPDATE_ACTIVE_PLAYLIST = 'home/UPDATE_ACTIVE_PLAYLIST'

const GET_HOME_RESUME_VIDEO_LOADING = 'home/GET_HOME_RESUME_VIDEO_LOADING'
const GET_HOME_RESUME_VIDEO_SUCCESS = 'home/GET_HOME_RESUME_VIDEO_SUCCESS'
const GET_HOME_RESUME_VIDEO_ERROR = 'home/GET_HOME_RESUME_VIDEO_ERROR'

const GET_RECOMMENDATION_USER_LOADING = 'home/GET_RECOMMENDATION_USER_LOADING'
const GET_RECOMMENDATION_USER_SUCCESS = 'home/GET_RECOMMENDATION_USER_SUCCESS'
const GET_RECOMMENDATION_USER_ERROR = 'home/GET_RECOMMENDATION_USER_ERROR'

const HOME_VIDEO_REMINDERS = 'home/HOME_VIDEO_REMINDERS'
const HOME_VIDEO_REMINDERS_LOADING = 'home/HOME_VIDEO_REMINDERS_LOADING'

const GET_HOME_PL_LOADING = 'home/GET_HOME_PL_LOADING'
const GET_HOME_PL_SUCCESS = 'home/GET_HOME_PL_SUCCESS'
const GET_HOME_PL_ERROR = 'home/GET_HOME_PL_ERROR'

export {
  GET_HOME_PLAYLIST_LOADING,
  GET_HOME_PLAYLIST_SUCCESS,
  GET_HOME_PLAYLIST_ERROR,
  GET_HOME_BANNER_LOADING,
  GET_HOME_BANNER_SUCCESS,
  GET_HOME_BANNER_ERROR,
  GET_HOME_VIDEO,
  UPDATE_ACTIVE_PLAYLIST,
  GET_HOME_RESUME_VIDEO_LOADING,
  GET_HOME_RESUME_VIDEO_SUCCESS,
  GET_HOME_RESUME_VIDEO_ERROR,
  GET_RECOMMENDATION_USER_LOADING,
  GET_RECOMMENDATION_USER_SUCCESS,
  GET_RECOMMENDATION_USER_ERROR,
  HOME_VIDEO_REMINDERS,
  HOME_VIDEO_REMINDERS_LOADING,
  GET_HOME_PL_LOADING,
  GET_HOME_PL_SUCCESS,
  GET_HOME_PL_ERROR,
}
